import type { ApiTypes } from '@hyundai/ng-common-lib';
import { EditFeature } from '../../../../+state';
import type { EditConfirmDialogData } from '../confirm.dialog';

export enum DealerCampaignDeleteConfirmActions {
    DELETE = 'delete',
    CANCEL = 'cancel',
}

export function dealerCampaignDeleteConfirmDialogData(
    id: ApiTypes.DealerCampaignEditDetail['id'],
): EditConfirmDialogData {
    return {
        headline: 'Bestätigen',
        copy: 'Möchten Sie wirklich löschen?',
        buttons: [
            {
                identifier: DealerCampaignDeleteConfirmActions.DELETE,
                label: 'Bestätigen',
                action: EditFeature.actions.deleteDealerCampaign({ campaignId: id }),
            },
            {
                identifier: DealerCampaignDeleteConfirmActions.CANCEL,
                label: 'Abbrechen',
            },
        ],
    };
}
